import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M5 19h14a2 2 0 0 0 1.84 -2.75l-7.1 -12.25a2 2 0 0 0 -3.5 0l-7.1 12.25a2 2 0 0 0 1.75 2.75","key":"svg-0"}]]

/**
 * IconBleach
 * @preview ![img](data:image/svg+xml;base64,PHN2ZwogIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIKICB3aWR0aD0iMjQiCiAgaGVpZ2h0PSIyNCIKICB2aWV3Qm94PSIwIDAgMjQgMjQiCiAgZmlsbD0ibm9uZSIKICBzdHJva2U9ImN1cnJlbnRDb2xvciIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCiAgY2xhc3M9Imljb24gaWNvbi10YWJsZXIgaWNvbnMtdGFibGVyLW91dGxpbmUgaWNvbi10YWJsZXItYmxlYWNoIgo+CiAgPHBhdGggc3Ryb2tlPSJub25lIiBkPSJNMCAwaDI0djI0SDB6IiBmaWxsPSJub25lIiAvPgogIDxwYXRoIGQ9Ik01IDE5aDE0YTIgMiAwIDAgMCAxLjg0IC0yLjc1bC03LjEgLTEyLjI1YTIgMiAwIDAgMCAtMy41IDBsLTcuMSAxMi4yNWEyIDIgMCAwIDAgMS43NSAyLjc1IiAvPgo8L3N2Zz4=) - https://tabler.io/icons/icon/bleach
 * @see https://docs.tabler.io/icons/libraries/react - Documentation
 *
 */
const IconBleach = createReactComponent('outline', 'bleach', 'Bleach', __iconNode);

export default IconBleach;